export enum MaintenanceFrequency {
    OneTime = 'one-time',
    Weekly = 'weekly',
    Monthly = 'monthly',
    Quarterly = 'quarterly',
    BiAnnually = 'bi-annually',
    Annually = 'annually',
    None = 'none'
}

export enum MaintenanceType {
    Routine = 'routine',
    Inspection = 'inspection',
    Upgrade = 'upgrade',
    Preventive = 'preventive',
    Seasonal = 'seasonal'
}

export enum MaintenanceStatus {
    Scheduled = 'scheduled',
    InProgress = 'in_progress',
    Completed = 'completed',
    Overdue = 'overdue',
    Canceled = 'canceled',
    Pending = 'pending'
}

export class Maintenance {
    maintenanceUID?: string;
    propertyUID?: string;
    propertyName?: string;
    buildingUID?: string;
    buildingName?: string;
    // Syndic context — optional unit within the building (common-parts tasks
    // leave it unset).
    unitUID?: string;
    unitName?: string;
    title!: string;
    description!: string;
    type: MaintenanceType = MaintenanceType.Routine;
    status: MaintenanceStatus = MaintenanceStatus.Scheduled;
    scheduledDate!: Date;
    completedDate?: Date;
    estimatedCost?: number;
    actualCost?: number;
    priority?: string;
    estimatedDuration?: number;
    assignedTo?: string;
    frequency: MaintenanceFrequency = MaintenanceFrequency.OneTime;
    isRecurring?: boolean;
    notes?: string;
    attachments?: string[]; // URLs to documents/images (legacy field)
    documentUIDs?: string[]; // References to Document entities in the document service
    nextScheduledDate?: Date;
    recurrenceRule?: string; // For complex recurrence patterns
    /** Default service provider for this recurring maintenance. When set together with `autoReminderEnabled`, the cockpit auto-creates an INVITE_PROVIDER card at each due date. */
    defaultProviderId?: string;
    /** When true, the cockpit raises a card ahead of `nextScheduledDate` and auto-sends the request to `defaultProviderId` after the cancel window unless the user cancels. */
    autoReminderEnabled?: boolean;
    /** How many days before `nextScheduledDate` the card appears in the cockpit. Defaults to 10 in the sweep when omitted. */
    leadTimeDays?: number;
    /** How many days the user can cancel before auto-execution fires. Defaults to 3 in the sweep when omitted. */
    cancelWindowDays?: number;
    ownerUID!: string;
    createdAt: Date = new Date();
    updatedAt: Date = new Date();

    constructor(data: Partial<Maintenance> = {}) {
        Object.assign(this, data);
        // Set defaults for required fields if not provided
        if (!this.createdAt) this.createdAt = new Date();
        if (!this.updatedAt) this.updatedAt = new Date();
        if (!this.status) this.status = MaintenanceStatus.Pending;
        if (!this.type) this.type = MaintenanceType.Routine;
        if (!this.frequency) this.frequency = MaintenanceFrequency.None;
        if (this.isRecurring === undefined) this.isRecurring = false;
    }
} 